export const PRODUCT_MENU_STATE_ENUM = {
  FAMILIES: 'FAMILIES',
  CATEGORIES: 'CATEGORIES',
  SUBCATEGORIES: 'SUBCATEGORIES',
};
